import { type IApplicationContext } from 'shared/types/applicationContext';
import { type IApplicationState, type TReduxStore } from 'shared/types/redux';
import { createReduxStore } from 'shared/utils/redux';

export function createApplicationState(context: IApplicationContext): TReduxStore {
  const { config } = context;

  const initialState = config.getStrict<IApplicationState>('initialState');

  return createReduxStore({ context, debugEnabled: true, initialState });
}
